import { httpRequest } from "@utils/HttpRequest";
import {
    IPage,
} from "@src/types/FmsTypes";
import { IMdAppStatistic, IMdAppStatisticFields, IMdAppStatisticSearch } from "./AppStatisticTypes";




class AppStatisticService {
    async insert(insertVo: IMdAppStatisticFields) {
        const appInsertUrl = "/auth/app/insert";
        let ret = await httpRequest.post<IMdAppStatistic>(appInsertUrl, insertVo);
        return ret;
    }

    async disable(oneVo: IMdAppStatisticFields) {
        const appDisableUrl = "/auth/app/disable";
        let ret = await httpRequest.post<boolean>(appDisableUrl, oneVo);
        return ret;
    }

    async find(searchVo: IMdAppStatisticFields) {
        const appPageUrl = "/auth/app/find";
        return await httpRequest.post<IMdAppStatistic[]>(appPageUrl, searchVo);
    }

    async appDs(searchVo: IMdAppStatisticFields) {
        let { retData } = await this.find(searchVo);
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }

    async page(searchVo: IMdAppStatisticSearch) {
        const appPageUrl = "/auth/app/appStatistic";
        return await httpRequest.post<IPage<IMdAppStatistic>>(appPageUrl, searchVo);
    }

    async one(oneVo: IMdAppStatisticFields) {
        const appDisableUrl = "/auth/app/one";
        return await httpRequest.post<IMdAppStatistic>(appDisableUrl, oneVo);
    }

    async sync(syncVo: IMdAppStatisticFields) {
        const appPageUrl = "/auth/app/sync";
        syncVo.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(appPageUrl, syncVo, {
            timeout: 15000
        });
    }

    async syncPage(searchVo: IMdAppStatisticSearch) {
        const appPageUrl = "/auth/app/syncPage";
        searchVo.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(appPageUrl, searchVo);
    }

    async syncOne(oneVo: IMdAppStatisticFields) {
        const appPageUrl = "/auth/app/syncPage";

        return await httpRequest.post<boolean>(appPageUrl, oneVo);
    }
}

export const appIntegrateService = new AppStatisticService();
